import { Form, useNavigate } from "react-router-dom";

import { Box, Button, Heading, Link } from "@ogt/ui";

export default function Fail() {
  const navigate = useNavigate();

  return (
    <div>
      <Form>
        <Box>
          <Heading focusable>Något gick fel!</Heading>
          <p>
            Vi kunde tyvärr inte ta emot er överklagan just nu på grund av ett
            fel på vår sida. Vi ber er att prova senare alternativt ringa till
            oss på telefonnummer <Link className="inline!" underline="always" href="tel:0771211010">
              0771 – 21 10 10
            </Link> så
            hjälper vi er vidare.
          </p>
        </Box>
        <div className="flex justify-center">
          <div className="w-full text-left flex items-center">
            <Button
              iconPosition="left"
              iconSize={16}
              iconName="arrow-left"
              aria-label="Tillbaka"
              showIcon
              size="medium"
              variant="outline"
              onClick={(event) => {
                event.preventDefault();
                const backUrl = undefined;
                if (backUrl) {
                  navigate(backUrl, { replace: true });
                } else {
                  navigate(-1);
                }
              }}
            >
              Tillbaka
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
}
